const menu = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M14.5 12.703V14.5h-13v-1.797zm0-5.601v1.796h-13V7.102zm0-5.602v1.797h-13V1.5z"/></svg>',
};

export { menu as default };
